import { h } from "preact";
import { classNames } from "../helpers.js";

import Avatar from "./Avatar.jsx";
import ListItem from "./ListItem.jsx";
import { getPositionFromUser } from "../talentHelpers.js";

export default function TalentListItem({ user, ...props }) {
  const position = getPositionFromUser(user);
  const content = [position, user.country].filter((x) => x);

  const avatar = props.noAvatar ? null : (
    <div class="talent-list-item__avatar">
      <Avatar user={user} plain big={props.big} medium={!props.big} />
    </div>
  );

  return (
    <ListItem
      {...props}
      class={classNames(
        "talent-list-item",
        props.class,
        props.big && "talent-list-item--big"
      )}
      iconFront={avatar}
    >
      <div class="talent-list-item__content">
        <div
          class={
            props.big ? "t-h5" : "t-subtitle1 t-subtitle1--margin-small pt-0"
          }
        >
          {user.name}
        </div>
        {content.length > 0 && (
          <div class="t-body4 color-shades-dim-grey">{content.join(", ")}</div>
        )}
      </div>
    </ListItem>
  );
}
